import { MultipleQueriesQuery } from '@algolia/client-search'

export const algoliaQueryEmptyResponse = (requests: readonly MultipleQueriesQuery[]) => {
  return Promise.resolve({
    results: requests.map(() => ({
      hits: [],
      nbHits: 0,
      nbPages: 0,
      page: 0,
      processingTimeMS: 0,
      hitsPerPage: 0,
      exhaustiveNbHits: false,
      query: '',
      params: '',
    })),
  })
}
